<section class="transfer">
<div #tenasferModal id="transfer" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" class="modal fade text-left">
    <div role="document" class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header"><strong id="exampleModalLabel" class="modal-title">Notification Title</strong>
          <button type="button" data-dismiss="modal" aria-label="Close" class="close"><span aria-hidden="true">×</span></button>
        </div>
        <div class="modal-body">
            <section class="no-padding-top">
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-lg-12">
                        <div class="block">
                          <div class="title"><strong>Transfer Funds To Other Account</strong></div>
                          <!-- <button type="submit" class="btn btn-secondary">Cancel</button> -->
                          <div class="block-body">
                            <form [formGroup]="transferData" class="form-horizontal"  (ngSubmit)="send()">
                              <div class="form-group row">
                                <label class="col-sm-3 form-control-label">Account Number</label>
                                <div class="col-sm-9">
                                  <input type="text" 
                                  class="form-control" 
                                  formControlName="receiverAccountNumber"
                                  id="receiverAccountNumber"
                                  name="receiverAccountNumber"
                                  (keyup)="getRecieverName($event.target)"
                                  placeholder="Recepient Thrively Account Number" 
                                  autocomplete="off" 
                                  maxlength="10"
                                  required>
                                  <span *ngIf="labelFlag" style="color: red; font-size: 12px;"> {{userData?.firstname}} {{userData?.lastname}} </span>
                                  <span *ngIf="!labelFlag" style="color: red; font-size: 12px;"> {{errorMes}} </span>
                                </div>
                              </div>
                              <div class="line"></div>
        
                              <div class="form-group row">
                                <label class="col-sm-3 form-control-label">Amount</label>
                                <div class="col-sm-9">
                                  <input type="number" 
                                  class="form-control"
                                  formControlName="amount"
                                  id="amount"
                                  name="amount" 
                                  placeholder="" 
                                  autocomplete="off" 
                                  required>
                                </div>
                              </div>
                              <div class="line"></div>
        
                             
                             
                              <div class="line"></div>
                              <div class="form-group row">
                                <div class="col-sm-9 ml-auto">
                                 
                                  <button type="submit" [disabled]="transferData.invalid" class="btn btn-primary">Initiate Transaction</button>
                                </div>
                              </div>

                              <div class="line"></div>
                              <div class="form-group row">
                                <div class="col-sm-9 ml-auto">
                                 <p style="color: red;"> {{msg}} </p>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                  </div>
                </div>
            </section>
       
        </div>
        <div class="modal-footer">
            <p>Time</p>
        </div>
      </div>
    </div>
  </div>

  </section>